import { render, staticRenderFns } from "./list-room.vue?vue&type=template&id=11fa1f0a"
import script from "./list-room.vue?vue&type=script&lang=js"
export * from "./list-room.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports